export const ANRISTU_MS27103A = {
  DEFAULT_PORT: '9001',
  RBW_VALUES: [
    'AUTO',
    '3 MHz',
    '1 MHz',
    '300 kHz',
    '100 kHz',
    '30 kHz',
    '10 kHz',
    '3 kHz',
    '1 kHz',
    '300 Hz',
    '100 Hz',
    '30 Hz',
    '10 Hz',
  ],
  VBW_VALUES: [
    'AUTO',
    '3 MHz',
    '1 MHz',
    '300 kHz',
    '100 kHz',
    '30 kHz',
    '10 kHz',
    '3 kHz',
    '1 kHz',
    '300 Hz',
    '100 Hz',
    '30 Hz',
    '10 Hz',
  ],
  PREAMP_VALUES: ['OFF', 'ON'],
  ATTEN_VALUES: ['AUTO', '0 dB', '10 dB', '20 dB', '30 dB', '40 dB', '50 dB'],
  SWEEP_TIME_ENABLED: true,
  DETECTION_MODE_VALUES: ['Positive', 'RMS', 'Negative'],
  IMAGES: {
    connected: 'unit-rx4-connected.png',
    disconnected: 'unit-rx4-disconnected.png',
    lostConnection: 'unit-rx4-lostconnection.png',
  },
  parseIdnResponse: (idnResponse: string) => {
    const splitResponse = idnResponse.split(',');

    return {
      model: splitResponse[1],
      serial: splitResponse[2],
    };
  },
};
